<template>
  <div class="flex mb-2" style="position:relative">
    <loading :active="showAdvertisingMixMyside"
            :can-cancel="true"
            :on-cancel="onCancel"
            :is-full-page="false"
            :color="'#fff'"
            :background-color="'#000'"
            :opacity="'0.8'"
            :loader=" dots">
    </loading>
    <div ref="ecdMix" class="flex-1 bg-white rounded-xl space-y-6 p-6" style="min-width:0;">
      <div>
        <span class="text-red-500">*</span>
        <span class="text-grap-700 align-middle">{{ lang['components']['Event']['EcdMix']['title'] }}</span>
      </div>
      <div class="flex-1 space-y-4">
        <div class="space-y-2">
          <div class="flex justify-between">
            <span class="text-grap-700 text-sm pt-4">{{ lang['components']['Event']['EcdMix']['audience_label'] }}</span>
            <button
              v-if="!editPageType"
              class="text-blue-600 focus:outline-none rounded-xl px-4 py-1 transition duration-500 ease-in-out border-2 border-blue-600"
              @click="audience_update()"
            >
              <i class="pi pi-refresh"></i>
              {{ lang['components']['Event']['EcdMix']['update'] }}
            </button>
          </div>
          <MultiSelect
            :disabled="editPageType"
            v-model="viewDatalistData.ecd_audiences"
            :options="viewDatalistData.ecdAudienceList"
            optionValue="id"
            optionLabel="name"
            :placeholder="lang['components']['Event']['EcdMix']['placeholder']" 
            :filter="true"
            class="w-full multiselect-custom"
            display="chip"
          >
          </MultiSelect>
        </div>
      </div>
    </div>
    <div class="hidden lg:block rounded-xl space-y-2 px-4 event-tips-sidebar">
      <div class="flex flex-col bg-white rounded-xl space-y-4 p-4">
        <span class="text-gray-700">{{ lang['components']['Event']['EcdMix']['select_block_title'] }}</span>
        <div
          class="flex flex-col bg-white w-full p-2 rounded-xl border h-48 overflow-y-auto"
        >
          <template v-for="tagCode in viewDatalistData.ecd_audiences" :key="tagCode">
            <div
              class="flex justify-between rounded m-1 px-2 py-1 text-sm cursor-pointer w-none bg-blue-400 text-white"
              @click="removeSelectCustomTags(tagCode)"
            >
              <span style="word-break: break-all;">{{ getAudienceName(tagCode) }}</span>
              <i class="pi pi-times mt-1" v-if="!editPageType" style="fontSize: 0.8rem"></i>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import MultiSelect from "primevue/multiselect";
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/dist/sweetalert2.min.css'
import Loading from 'vue3-loading-overlay';
import 'vue3-loading-overlay/dist/vue3-loading-overlay.css';
import axios from 'axios'
import Qs from 'qs'

export default {
  name: "EcdMix",
  components: {
    MultiSelect,
    Loading
  },
  props: {
    showEcdMix: {
      type: Boolean
    },
    editPage: {
      type: Boolean
    },
    adaccountId: {
      type: String
    },
    viewDatalist: {
      type: Object
    },
    lang: {
      type: Object
    },
  },
  data() {
    return {
      showAdvertisingMixMyside: false,
      dots: 'dots'
    };
  },
  methods: {
    getAudienceName(id) {
      if (!this.viewDatalistData.ecdAudienceList) return id;
      const option = this.viewDatalistData.ecdAudienceList.find(o => o.id === id);
      return option ? option.name : id;
    },
    removeSelectCustomTags(id) {
      if(this.editPageType) return;
      for (let i = 0; i < this.viewDatalistData.ecd_audiences.length; i++) {
        if (this.viewDatalistData.ecd_audiences[i] === id) {
          this.viewDatalistData.ecd_audiences.splice(i, 1);
        }
      }
    },
    audience_update(){
      if(this.editPageType == false){
        this.loadAudienceList();
      }
    },
    loadAudienceList(){
        const L = this.lang?.['components']?.['Event']?.['EcdMix']?.['methods'] || {};
        this.showAdvertisingMixMyside = true;
        axios
          .post('https://www.autoturn.net/api/campaign_audience_ecd_update.php', Qs.stringify({
            s_code: this.$route.params.id,
            adaccount_id: this.adaccountIdData,
          }))
          .then((response) => {
            if(response.data.status == 'success'){
              this.viewDatalistData.ecdAudienceList = response.data.return_data;
            } else {
              Swal.fire(L.swal_error_title, response.data.info || L.swal_error_text, 'error');
            }
            this.showAdvertisingMixMyside = false;
          }).catch(err => {
            this.showAdvertisingMixMyside = false;
          });
    },
    onCancel() {
        this.showAdvertisingMixMyside = false;
    }
  },
  computed: {
    editPageType: {
      get: function () {
        return this.editPage
      },
      set: function (value) {
        this.$emit('update:editPageType', value)
      },
    },
    adaccountIdData: {
      get: function () {
        return this.adaccountId
      },
      set: function (value) {
        this.$emit('update:adaccountIdData', value)
      },
    },
    viewDatalistData: {
      get: function () {
        return this.viewDatalist
      },
      set: function (value) {
        this.$emit('update:viewDatalistData', value)
      },
    }
  },
  mounted() {
      if(!this.viewDatalistData.ecdAudienceList || this.viewDatalistData.ecdAudienceList.length === 0) {
          this.loadAudienceList();
      }
  }
};
</script>
<style lang="scss" scoped>
::v-deep(.multiselect-custom) {
  .p-multiselect-label-container {
    max-height: 120px;
    overflow-y: auto;
  }
  .p-multiselect-token {
    font-size: 0.875rem;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    border-radius: 0.25rem;
    display: inline-flex;
    margin: 0.25rem;
    --tw-bg-opacity: 1;
    background-color: rgba(96, 165, 250, var(--tw-bg-opacity));
    --tw-text-opacity: 1;
    color: rgba(255, 255, 255, var(--tw-text-opacity));
  }
}
</style>
